import "@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap-css-only/css/bootstrap.min.css";
import "mdbvue/lib/mdbvue.css";
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./state/store";
import axios from "axios";
import LoadScript from "vue-plugin-load-script";
import Toasted from "vue-toasted";

axios.interceptors.response.use(undefined, function(err) {
  return new Promise(function() {
    if (
      err.response.status === 401 &&
      err.config &&
      !err.config.__isRetryRequest
    ) {
      store.dispatch("user/logout");
      store.commit("set_login_redirect_url", location.pathname);
      router.push("/login");
    }
    throw err;
  });
});

axios.defaults.baseURL = "https://virallyze.com/api/v1";

Vue.prototype.$http = axios;

const token = localStorage.getItem("token");
if (token) {
  Vue.prototype.$http.defaults.headers.common["Authorization"] = token;
}

Vue.use(LoadScript);
Vue.use(Toasted);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
